import * as React from "react"

export function AuthShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-page px-4 py-12 text-ink-body">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(59,130,246,0.08),transparent_34%),radial-gradient(circle_at_bottom_left,rgba(30,64,175,0.06),transparent_30%)] dark:bg-[radial-gradient(circle_at_top_right,rgba(96,165,250,0.10),transparent_34%),radial-gradient(circle_at_bottom_left,rgba(37,99,235,0.08),transparent_30%)]" />
      <div className="relative w-full max-w-md">
        <div className="mb-5 flex items-center justify-center">
          <div className="inline-flex items-center rounded-full border border-hairline bg-surface px-4 py-2 shadow-sm">
            <img
              src="/ResidentialLeadFlow-LightMode.png?v=20260827-residential-2"
              alt="Residential LeadFlow"
              className="h-7 w-auto shrink-0 object-contain dark:hidden"
              loading="eager"
              decoding="async"
            />
            <img
              src="/ResidentialLeadFlow-Login-DarkMode.png?v=20260827-residential-2"
              alt="Residential LeadFlow"
              className="hidden h-7 w-auto shrink-0 object-contain dark:block"
              loading="eager"
              decoding="async"
            />
          </div>
        </div>
        <div className="callout border-hairline bg-surface shadow-[0_18px_60px_rgba(15,23,42,0.08)]">
          {children}
        </div>
      </div>
    </div>
  )
}
